import { decryptData } from "@/utils/crypto";
import apiService from "./apiService";

const authService = {
    async getCurrentUser() {
        return decryptData(localStorage.getItem('token'));
    },
    async signup(payload) {
        const resp = await apiService.post(`auth/signup`, payload);
        return resp.data;
    },
    async googleLogin(payload) {
        const resp = await apiService.post(`auth/google-login`, payload);
        return resp.data;
    },
    async forgotPassword(payload) {
        const resp = await apiService.post(`auth/forgot-password`, payload);
        return resp.data;
    },
    async resetPassword(payload) {
        const resp = await apiService.post(`auth/reset-password`, payload);
        return resp.data;
    }
}

export default authService;